// Downscale a phone photo before upload. A show-floor snap is 4–8 MB; at 1600px
// / q0.82 it lands around 200–400 KB, which matters a lot on exhibition wifi.
export function compressImage(file, maxDim = 1600, quality = 0.82) {
  return new Promise((resolve) => {
    if (!file || !/^image\//i.test(file.type) || /heic|heif/i.test(file.type)) return resolve(file);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      try {
        const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
        if (scale === 1 && file.size < 900 * 1024) return resolve(file);
        const c = document.createElement('canvas');
        c.width  = Math.max(1, Math.round(img.width * scale));
        c.height = Math.max(1, Math.round(img.height * scale));
        const ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(
          (b) => resolve(b && b.size < file.size
            ? new File([b], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' })
            : file),
          'image/jpeg', quality
        );
      } catch { resolve(file); }
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });
}
